import {FormSection} from '@/components/commons/form-section/FormSection'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PlannedAccessesProjectCountersCard} from '@/features/planned-accesses/components/planned-accesses-project-counters-card/PlannedAccessesProjectCountersCard'
import {PlannedAccessesPsychosocialCard} from '@/features/planned-accesses/components/planned-accesses-psychosocial-card/PlannedAccessesPsychosocialCard'
import {PlannedAccessesFieldsSchema} from '@/features/planned-accesses/formSchemas'
import {useAbsenceThreshold} from '@/features/planned-accesses/hooks/useAbsenceThreshold'
import {usePlannedAccessesFormCounts} from '@/features/planned-accesses/hooks/usePlannedAccessesFormCounts'
import {useTranslation} from '@/translations/i18n'
import {useFormContext, useWatch} from 'react-hook-form'
import {PlannedAccessesMedicalCard} from '../../planned-accesses-medical-card/PlannedAccessesMedicalCard'

export const PlannedAccessesFormTotalSection = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<PlannedAccessesFieldsSchema>()

    // Extract form values using useWatch
    const projectId = useWatch({control, name: 'projectId'})
    const absenceAccesses = useWatch({control, name: 'absenceAccesses'}) || []
    const inPersonAccesses = useWatch({control, name: 'inPersonAccesses'}) || []
    const singleAccesses = useWatch({control, name: 'singleAccesses'}) || []

    const {
        project,
        totalAbsencesAccessesCount,
        totalInPresenceAccessCount,
        totalPsychosocialAccessesCount,
        totalMedicalAccessesCount,
        totalTreatmentAccessesCount
    } = usePlannedAccessesFormCounts({
        projectId,
        absenceAccesses,
        inPersonAccesses,
        singleAccesses
    })

    const {selectedAbsenceThresholdPercentage} = useAbsenceThreshold({
        assistiveRegime: project?.assistiveRegime ?? null,
        serviceType: project?.patient.serviceType ?? null,
        totalInPresenceAccessesCount: totalInPresenceAccessCount ?? 0
    })

    return (
        <FormSection title={t('commons:totals')} hasBottomDivider>
            <Flexbox direction="column" gap={6}>
                <PlannedAccessesProjectCountersCard
                    totalInPresenceAccessCount={totalInPresenceAccessCount}
                    totalAbsencesAccessesCount={totalAbsencesAccessesCount}
                    selectedAbsenceThresholdPercentage={selectedAbsenceThresholdPercentage}
                    assistiveRegime={project?.assistiveRegime ?? null}
                    serviceType={project?.patient.serviceType ?? null}
                />

                <PlannedAccessesMedicalCard
                    totalTreatmentAccessesCount={totalTreatmentAccessesCount}
                    totalMedicalAccessesCount={totalMedicalAccessesCount}
                />

                <PlannedAccessesPsychosocialCard
                    totalTreatmentAccessesCount={totalTreatmentAccessesCount}
                    totalPsychosocialAccessesCount={totalPsychosocialAccessesCount}
                />
            </Flexbox>
        </FormSection>
    )
}
